/* ORRA Glam — Buy Now. Adds the chosen variant/quantity then opens standard Shopify checkout.
   Texts come from window.orraStrings (locales: orra.buy_now.*), with English fallbacks. */
(function(){
  "use strict";
  if(window.__orraBuyNowInitialized)return;
  window.__orraBuyNowInitialized=true;
  var S=Object.assign({
    label:"BUY NOW",processing:"PROCESSING...",ariaLabel:"Buy now — go directly to checkout",
    errorNoForm:"Unable to find product form. Please use Add to Cart.",
    errorUnavailable:"Please select an available product option.",
    errorSelectOption:"Please select a product option.",
    errorQuantity:"Please select a valid quantity.",
    errorAddFailed:"Could not add this item. Please try again.",
    errorGeneric:"Something went wrong. Please try again."
  },window.orraStrings||{});
  function applyLabels(root){
    (root||document).querySelectorAll("[data-orra-buy-now]").forEach(function(btn){
      if(btn.dataset.loading==="true")return;
      var t=btn.querySelector(".orra-buy-now__text");
      if(t&&t.textContent!==S.label)t.textContent=S.label;
      if(btn.getAttribute("aria-label")!==S.ariaLabel)btn.setAttribute("aria-label",S.ariaLabel);
    });
  }
  function initLabels(){
    applyLabels();
    new MutationObserver(function(){applyLabels();}).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",initLabels);else initLabels();
  document.addEventListener("click",async function(event){
    const button=event.target.closest("[data-orra-buy-now]");
    if(!button||button.disabled||button.dataset.loading==="true")return;
    event.preventDefault();
    const container=button.closest(".hdt-product__buy-button");
    const form=container&&container.querySelector("form.hdt-main-product-form");
    const error=container&&container.querySelector("[data-orra-buy-now-error]");
    const loader=button.querySelector(".orra-buy-now__loading");
    const label=button.querySelector(".orra-buy-now__text");
    function showError(message){
      if(error){error.textContent=message;error.hidden=false;}
    }
    if(!form){showError(S.errorNoForm);return;}
    if(error){error.hidden=true;error.textContent="";}
    const atc=form.querySelector('button[name="add"]');
    if(atc&&atc.disabled){showError(S.errorUnavailable);return;}
    const payload=new FormData(form);
    const id=payload.get("id");
    if(!id||!/^\d+$/.test(String(id))){
      showError(S.errorSelectOption);
      return;
    }
    const qty=Number(payload.get("quantity")||1);
    if(!Number.isSafeInteger(qty)||qty<1){
      showError(S.errorQuantity);
      return;
    }
    button.disabled=true;button.dataset.loading="true";
    if(loader)loader.hidden=false;
    if(label)label.textContent=S.processing;
    try{
      const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/";
      const path=root.endsWith("/")?root:root+"/";
      const response=await fetch(path+"cart/add.js",{
        method:"POST",
        body:payload,
        credentials:"same-origin",
        headers:{"Accept":"application/json","X-Requested-With":"XMLHttpRequest"}
      });
      if(!response.ok){
        let body={};
        try{body=await response.json()}catch(_){}
        throw new Error(body.description||body.message||S.errorAddFailed);
      }
      // Keeps previously added items; normal checkout permits every enabled payment method.
      window.location.assign(path+"checkout");
    }catch(err){
      showError((err&&err.message)||S.errorGeneric);
      button.disabled=false;delete button.dataset.loading;
      if(loader)loader.hidden=true;
      if(label)label.textContent=S.label;
    }
  });
})();

/* ORRA: fill the cart drawer trust area with the store's real payment icons (no external hotlinks). */
(function(){
  "use strict";
  function fill(){
    var drawer=document.getElementById("CartDrawer");
    if(!drawer)return;
    var tpl=drawer.querySelector("#orra-pay-icons-tpl");
    var slot=drawer.querySelector(".hdt-mini-cart__imgtrust");
    if(!tpl||!slot||slot.querySelector(".orra-payment-icons"))return;
    slot.appendChild(tpl.content.cloneNode(true));
    var icons=slot.querySelector(".orra-payment-icons");
    if(icons)icons.style.justifyContent="center";
  }
  function start(){
    fill();
    var target=document.querySelector("hdt-cart-drawer")||document.body;
    new MutationObserver(fill).observe(target,{childList:true,subtree:true});
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start);else start();
})();
